// Using 45x45 as the base — matches mobile scaleW(45) for cross-platform consistency
export const PIN_SIZE = { width: 45, height: 45 };
// Cluster bubble size (slightly larger to show count)
export const CLUSTER_SIZE = { width: 55, height: 55 };

export function resolvePin(channelData, MARKER) {
    const compositePinUrl = channelData?.teamData?.compositePinUrl;

    const premiumPin = channelData?.premiumPinCategory?.pin;
    const normalPin = channelData?.normalPinCategory?.pin;

    const url = compositePinUrl || premiumPin || normalPin || MARKER['default'];

    // Check for active events (Part 2 — event badge)
    const activeEvents = channelData?.activeEvents;
    const hasEventBadge = activeEvents && activeEvents.length > 0;
    const eventIconUrl = hasEventBadge ? activeEvents[0]?.eventType?.image : null;

    return { url, hasEventBadge, eventIconUrl };
}
